import {
  Swiper,
  Navigation,
  Pagination,
  Keyboard
} from 'swiper';

Swiper.use([Navigation, Pagination, Keyboard]);


const sliderSections = document.querySelectorAll(".s-dev-project-slide");

sliderSections.forEach(slideSection => {
  const slider = slideSection.querySelector(".s-dev-project-slide__slider");
  const buttonPrev = slideSection.querySelector(".swiper-button-prev");
  const buttonNext = slideSection.querySelector(".swiper-button-next");

  const swiperSettings = {
    navigation: {
      nextEl: buttonNext,
      prevEl: buttonPrev,
    },
    keyboard: true,
    draggable: true,
    slidesPerView: 1,
    spaceBetween: 8,
    updateOnWindowResize: true,
    breakpoints: {
      767: {
        slidesPerView: 2,
        spaceBetween: 16
      },
      991: {
        slidesPerView: 3,
        spaceBetween: 16
      },
      1200: {
        slidesPerView: 4,
        spaceBetween: 16
      },
      1500: {
        slidesPerView: 5,
        spaceBetween: 16
      },
      1920: {
        slidesPerView: 6,
        spaceBetween: 16
      },
    }
  };

  new Swiper(slider, swiperSettings);
});
